import { Link } from '@tanstack/react-router';
import { ICard } from '../../types/card';
import fallbackCardImage from '../../assets/cardImages/benefits-summary.jpg';

interface CardProps {
  cardData: ICard;
}

/**
 * Individual card
 *
 * @param cardData
 * @returns
 */
const Card: React.FC<CardProps> = ({ cardData }) => {
  const CardContent = (
    <div className="flex h-full flex-col bg-white border border-gray-300 rounded-lg relative hover:bg-gray-50">
      <div
        className="rounded-t-lg object-cover h-40 scale-x-[-1]"
        style={{ objectPosition: 'center 60%' }}
      >
        {cardData.cardImage ? (
          <img
            className="w-full h-full object-cover rounded-t-lg"
            src={cardData.cardImage}
            alt={cardData.header}
          />
        ) : (
          <img
            className="w-full h-full object-cover rounded-t-lg"
            src={fallbackCardImage}
            alt={cardData.header}
          />
        )}
      </div>
      <div className="absolute translate-x-6 translate-y-30">
        <div className="rounded-full bg-[#b0557e]">{cardData.icon}</div>
      </div>
      <div className="flex flex-col py-8 px-4">
        <h3 className="text-lg font-bold tracking-tight text-gray-900 p-2">
          {cardData.header}
        </h3>
        {cardData.description && (
          <p className="text-sm tracking-tight text-gray-900 p-2">
            {cardData.description}
          </p>
        )}
      </div>
    </div>
  );

  return cardData.isHrefExternal ? (
    <a
      href={cardData.href}
      aria-label={'Link to ' + cardData.header}
      target="_blank"
      rel="noopener noreferrer"
    >
      {CardContent}
    </a>
  ) : (
    <Link to={cardData.href} aria-label={'Link to ' + cardData.header}>
      {CardContent}
    </Link>
  );
};

export default Card;
